import i18nKit from "./I18N.js"
let i18n = i18nKit.methods;


const dicts = {
    chromeVersion: "1.1.9",
    views: {
        userView : 0,
        stockView : 1,
        inventoryView:2,
    },
    cssTypes: [
        'warning',
        'success',
        'primary',
        'info',
        'danger',
        'success',
        'success',
        'success',
        'success',
        'success',
        'success',
        'success',
    ],
    
    //查询条件类型
    //0-文本，1-数字，2-下拉，3-日期范围
    queryTypes: [
        {
            label: i18n.msg("文本输入"),
            key: 0,
            value: [ //文本 操作符号
                {label: i18n.msg("等于"), value: 0},
                {label: i18n.msg("关键字包含"), value: 5},
                {label: i18n.msg("关键字左包含"), value: 9},
                {label: i18n.msg("多个文本"), value: 6},
            ],
        },
        {
            label: i18n.msg("数字输入"),
            key:1,
            value: [ //数字 操作符号
                {label: i18n.msg("等于"), value: 0},
                {label: i18n.msg("大于"), value: 1},
                {label: i18n.msg("大于等于"), value: 3},
                {label: i18n.msg("小于"), value: 2},
                {label: i18n.msg("小于等于"), value: 4},
            ],
        },
        {
            label: i18n.msg("下拉框"),
            key:2,
            value: [ //数字 操作符号
                {label: i18n.msg("单选"), value: 0},
                {label: i18n.msg("多选"), value: 6},
                {label: i18n.msg("多选（不包含）"), value: 8},
            ],
        },
        {
            label: i18n.msg("日期选择"),
            key:3
        },
        {
            label: i18n.msg("日期时间选择"),
            key:4
        },
    ],
    
    dateRanges: [
        {label: i18n.msg("近1天"), value: "1"},
        {label: i18n.msg("近3天"), value: "3"},
        {label: i18n.msg("近一周"), value: "7"},
        {label: i18n.msg("近两周"), value: "14"},
        {label: i18n.msg("近10天"), value: "10"},
        {label: i18n.msg("近半月"), value: "15"},
        {label: i18n.msg("近一月"), value: "30"},
    ],

    filterTypes: [
        {label: i18n.msg('搜索筛选器'), value: "search"}, //FilterInput
        {label: i18n.msg('内容分组筛选器'), value: "content"},   //FilterContent
        {label: i18n.msg('类型筛选器'), value: "type"}, 
        {label: i18n.msg('复合筛选器'), value: "complex"},   //FilterComplex
        {label: i18n.msg('日期筛选器'), value: "date"},   //FilterComplex
    ],

    adminTypes:[
        {label: i18n.msg("普通用户"), value: 0, type:"success"},
        {label: i18n.msg("管理员"), value: 1, type: "danger"},
    ],
    declareStatuses:[
        {label: i18n.msg("待调用"), value: 0, type:"primary"},
        {label: i18n.msg("调用中"), value: 1, type: "success"},
        {label: i18n.msg("已使用"), value: 2, type: "danger"},
    ],
    declareExpCod:[
        {label: i18n.msg("货到付款"), value: 1, type:"primary"},
        {label: i18n.msg("纯配送"), value: 3, type: "success"},
    ],
    declareTypes:[
        {label: i18n.msg("貨到付款"), value: 1, type:"warning"},
        {label: i18n.msg("純配送"), value: 3, type: "success"},
    ],
    genders:[
        {label: i18n.msg("男"), value: 0, type:"primary"},
        {label: i18n.msg("女"), value: 1, type:"warning"},
        {label: i18n.msg("保密"), value: 2, type:"success"},
    ],
    walletStatus:[
        {label: i18n.msg("未审核"), value: 0, type:"primary"},
        {label: i18n.msg("已审核"), value: 1, type:"success"},
        {label: i18n.msg("已取消"), value: 2, type:"warning"},
    ],
    walletPayStatus:[
        {label: i18n.msg("待付"), value: 0, type:"warning"},
        {label: i18n.msg("未结清"), value: 1, type:"warning"},
        {label: i18n.msg("已付"), value: 2, type:"success"},
        {label: i18n.msg("已结算"), value: 3, type:"success"},
        {label: i18n.msg("已取消"), value: 4, type:"success"},
    ],
    walletTypes: [
        // 0-充值,1-会员续费、2-提现,  3-运费结算、4-回款结算、5-其它支出
        {label: i18n.msg("充值"), value: 0, type:"primary"},
        // {label: i18n.msg("会员续费"), value: 1, type:"primary"},
        {label: i18n.msg("提现"), value: 2, type:"primary"},
        {label: i18n.msg("运费结算"), value: 3, type:"primary"},
        {label: i18n.msg("回款结算"), value: 4, type:"primary"},
        {label: i18n.msg("理赔"), value: 5, type:"primary"},
        {label: i18n.msg("其它支出"), value: 6, type:"primary"},
        {label: i18n.msg("客诉件结算"), value: 7, type:"primary"},
    ],
    walletTypes1: [
        // 0-充值,1-会员续费、2-提现,  3-运费结算、4-回款结算、5-其它支出
        {label: i18n.msg("充值"), value: 0, type:"primary"},
        {label: i18n.msg("会员续费"), value: 1, type:"primary"},
        {label: i18n.msg("提现"), value: 2, type:"primary"},
        {label: i18n.msg("运费结算"), value: 3, type:"primary"},
        {label: i18n.msg("回款结算"), value: 4, type:"primary"},
        {label: i18n.msg("理赔"), value: 5, type:"primary"},
        {label: i18n.msg("其它支出"), value: 6, type:"primary"},
        {label: i18n.msg("客诉件结算"), value: 7, type:"primary"},
    ],
    vipTypes:[
        {label: i18n.msg("普通用户"), value: 0, txt: "vip0", type:"primary"},
        {label: i18n.msg("普通会员"), value: 1,txt: "vip1",  type:"primary"},
        {label: i18n.msg("高级会员"), value: 2,txt: "vip2",  type:"success"},
        {label: i18n.msg("超级会员"), value: 3,txt: "vip3",  type:"danger"},
        {label: i18n.msg("试用会员"), value: 4,txt: "vip4",  type:"danger"},
        {label: i18n.msg("电商会员"), value: 5,txt: "vip5",  type:"danger"},
        {label: i18n.msg("物流会员"), value: 6,txt: "vip6",  type:"danger"},
        {label: i18n.msg("物流会员【标准版】"), value: 7,txt: "vip7",  type:"danger"},
        {label: i18n.msg("电商会员【标准版】"), value: 8,txt: "vip8",  type:"danger"},
        {label: i18n.msg("物流公司"), value: 9,txt: "vip9",  type:"danger"},
    ],
    vipOrderStatus:[
        {label: i18n.msg("待支付"), value: 0, type:"primary"},
        {label: i18n.msg("已支付"), value: 1, type:"success"},
        {label: i18n.msg("支付成功"), value: 2, type:"success"},
        {label: i18n.msg("未付款交易超时关闭"), value: 3, type:"info"},
        {label: i18n.msg("交易结束，不可退款"), value: 4, type:"danger"},
        {label: i18n.msg("取消支付"), value: 5, type:"danger"},
        {label: i18n.msg("已付款"), value: 6, type:"success"},
    ],
    userEditStatuses:[
        {label: i18n.msg("待审核"), value: 0},
        {label: i18n.msg("预付费"), value: 1},
        {label: i18n.msg("正常"), value: 5},
        {label: i18n.msg("审核不通过"), value: 10},
        {label: i18n.msg("禁用"), value: 15},
        {label:i18n.msg("已删除"),value:20},
    ],
    userStatuses:[
        {label:i18n.msg("待审核"),value:0, type:""},
        {label: i18n.msg("预付费"), value: 1},
        {label:i18n.msg("正常"),value:5, type:"success"},
        {label:i18n.msg("审核不通过"),value:10, type:"warning"},
        {label:i18n.msg("禁用"),value:15, type:"danger"},
        {label:i18n.msg("已删除"),value:20, type:"danger"},
    ],
    defaulteds:[ //是否默认
        {label:i18n.msg("否"),value:0, type:"warning"},
        {label:i18n.msg("是"),value:1, type:"success"},
    ],
    viewOnwerTypes: [
        {label: i18n.msg("所有视图"), value: 0},
        {label: i18n.msg("自定义视图"), value: 1},
        {label: i18n.msg("系统视图"), value: 2},
    ],
    viewCategories: [
        {label: i18n.msg("账户字段"), value: 0},
        {label: i18n.msg("货运字段"), value: 1},
        {label: i18n.msg("库存字段"), value: 2},
    ],
    readStatuses: [
        {label: i18n.msg("未读"), value: 0, type:"primary"},
        {label: i18n.msg("已读"), value: 1, type: "success"},
    ],
    messageTypes: [
        {label: i18n.msg("文本"), value: 0, type:"primary"},
        {label: i18n.msg("图片"), value: 1, type: "success"},
        {label: i18n.msg("文件"), value: 2, type: "danger"},
    ],
    noticeStatus:[
        {label: i18n.msg("未读"), value: 0, type:"warning"},
        {label: i18n.msg("已读"), value: 1, type:"success"},
    ],
    authType:[
        {label: i18n.msg("私有"), value: 0, type:"danger"},
        {label: i18n.msg("半公开"), value: 1, type:"warning"},
        {label: i18n.msg("公开"), value: 2, type:"success"},
    ],
    //计费方式
    feeTypes:[
        {label: i18n.msg("空运"), value: 0, type:"primary"},
        {label: i18n.msg("海运"), value: 1, type:"warning"},
        {label: i18n.msg("特殊1"), value: 3, type:"warning"},
        {label: i18n.msg("特殊2"), value: 4, type:"warning"},
        {label: i18n.msg("特殊3"), value: 5, type:"warning"},
        {label: i18n.msg("按票"), value: 2, type:"success"},
    ],
    //计重策略
    weightStraties:[
        {label: i18n.msg("实际重量"), value: 0, type:"primary"},
        {label: i18n.msg("向上取整"), value: 1, type:"warning"},
        {label: i18n.msg("全包"), value: 2, type:"success"},
    ],
    //单位类型
    units:[
        {label: i18n.msg("元/公斤"), value: 0, type:"primary"},
        {label: i18n.msg("元/票"), value: 1, type:"warning"},
    ],
    //货币币种
    currencies:[
        {label: i18n.msg("人民币"), value: 0, type:"primary"},
        {label: i18n.msg("台币"), value: 1, type:"warning"},
    ],
    userPkgTypes:[
        {label: i18n.msg("普通"), value: 0, type:"primary"},
        {label: i18n.msg("精细"), value: 1, type:"success"},
    ],
    stockExpPageStatus:[//台湾物流面单状态
        {label: i18n.msg("待通知"), value: 0},
        {label: i18n.msg("待上传"), value: 5},
        {label: i18n.msg("待处理"), value: 6},
        {label: i18n.msg("待同步"), value: 7},
        {label: i18n.msg("待打印"), value: 10},
        {label: i18n.msg("已打印"), value: 15},
        {label: i18n.msg("已过期"), value: 20},
    ],
    stockExpType:[//配送方式
        {label: i18n.msg("純配送"), value: 3},
        {label: i18n.msg("貨到付款"), value: 1},
    ],
    stockExpGoodType:[//货物类型
        {label: i18n.msg("普货"), value: 0, code: ''},
        {label: i18n.msg("特货"), value: 1, code: 'T'},
        {label: i18n.msg("C食品"), value: 2, code: 'C'},
        {label: i18n.msg("D电池类"), value: 3, code: 'D'},
        {label: i18n.msg("Y液体类"), value: 4, code: 'Y'},
        {label: i18n.msg("F(仿敏货别)"), value: 5, code: 'F'},
        {label: i18n.msg("KY货"), value: 6, code: ''},
    ],
    stockExpGoodTypeSim:[//货物类型
        {label: i18n.msg("普货"), value: 0, code: ''},
        {label: i18n.msg("KY货"), value: 6, code: ''},
    ],
    pasteRecordTypes:[//粘贴记录类型
        {label: i18n.msg("打包登记"), value: 0},
        {label: i18n.msg("贴单登记"), value: 1},
        {label: i18n.msg("打单失败"), value: 2},
        {label: i18n.msg("打单确认"), value: 3},
    ],
    stockExpPkgType:[//打包类型
        {label: i18n.msg("仓储包"), value: 0},
        {label: i18n.msg("发货打包"), value: 1},
        {label: i18n.msg("货运打包"), value: 5},
        {label: i18n.msg("转运打包"), value: 10},
        {label: i18n.msg("仓储现货包"), value: 15},
        {label: i18n.msg("拆合转寄包"), value: 20},
        {label: i18n.msg("单票转寄包"), value: 25},
        {label: i18n.msg("整包转寄包"), value: 27},
        {label: i18n.msg("过期转寄包"), value: 30},
        {label: i18n.msg("跨仓合并包"), value: 31},
        {label: i18n.msg("弃件打包"), value: 35},
        {label: i18n.msg("寄回打包"), value: 40},
    ],
    stockStoreType:[//仓储类型
        {label: i18n.msg("现货仓储"), value: 5},
        {label: i18n.msg("退件仓储"), value: 10},
        {label: i18n.msg("备货仓储"), value: 20},
        {label: i18n.msg("现收现发"), value: 30},
        {label: i18n.msg("过期仓储"), value: 35},
        {label: i18n.msg("集运仓储"), value: 40},
    ],
    batchUpdatestockStoreType:[//仓储类型
        {label: i18n.msg("现货仓储"), value: 5},
        {label: i18n.msg("现收现发"), value: 30},
    ],
    stockStoreType1:[//仓储类型1
        {label: i18n.msg("现货仓储"), value: 5},
        {label: i18n.msg("退件仓储"), value: 10},
        {label: i18n.msg("备货仓储"), value: 20},
        // {label: i18n.msg("过期仓储"), value: 35},
    ],
    stockStoreType2:[//仓储类型2
        {label: i18n.msg("现货仓储"), value: 5},
        {label: i18n.msg("备货仓储"), value: 20},
    ],
    stockInStoreStatus:[//入仓标签
        {label: i18n.msg("未打印"), value: 0},
        {label: i18n.msg("已打印"), value: 1},
    ],
    stockExpAllowPrint:[//能否列印面单
        {label: i18n.msg("不可以"), value: 0},
        {label: i18n.msg("可以"), value: 1},
        {label: i18n.msg("面单出货"), value: 2},
        {label: i18n.msg("自动获取"), value: 3},
    ],
    stockErrStatus:[//异常状态
        {label: i18n.msg("正常"), value: 0, type:"success"},
        {label: i18n.msg("异常"), value: 1, type:"danger"},
        {label: i18n.msg("已处理异常"), value: 2, type:"warning"},
        {label: i18n.msg("建单异常"), value: 3, type:"info"},
        {label: i18n.msg("萊爾富新面单"), value: 4, type:"primary"},
        {label: i18n.msg("待处理异常"), value: 5, type:"primary"},
    ],
    stockHasTax:[//是否含税
        {label: i18n.msg("不包税"), value: 0, type:"success"},
        {label: i18n.msg("包税"), value: 1, type:"primary"},
    ],
    isPublics :[//是否含税
        {label: i18n.msg("公共"), value: 0},
        {label: i18n.msg("私有"), value: 1},
    ],
    shopTypes:[
        {label: i18n.msg("虾皮"), value: 0, type:"success"},
        {label: i18n.msg("露天"), value: 1, type:"success"},
        {label: i18n.msg("奇摩"), value: 2, type:"success"},
        {label: i18n.msg("无"), value: 3, type:"success"},
        {label: i18n.msg("PChome"), value: 4, type:"success"},
        {label: i18n.msg("绿界"), value: 5, type:"success"},
        {label: i18n.msg("超商"), value: 6, type:"success"},
        {label: i18n.msg("虾皮(离线)"), value: 7, type:"success"},
        {label: i18n.msg("樂天市場"), value: 8, type:"success"},
        {label: i18n.msg("Shopline"), value: 9, type:"success"},
        {label: i18n.msg("MOMO"), value: 10, type:"warning"},
        {label: i18n.msg("Yahoo拍賣"), value: 11, type:"warning"},
        {label: i18n.msg("Coupang"), value: 12, type:"warning"},
    ],
    shopFilterTypes:[
        {label: i18n.msg("虾皮"), value: 0, type:"success"},
        {label: i18n.msg("MOMO"), value: 10, type:"warning"},
        {label: i18n.msg("Coupang"), value: 12, type:"warning"},
    ],
    orderOrigin:[
        {label: i18n.msg("店配"), value: 0, type:"success"},
        {label: i18n.msg("线下"), value: 1, type:"success"},
        {label: i18n.msg("转运"), value: 2, type:"success"},
        {label: i18n.msg("PDF"), value: 3, type:"success"},
        {label: i18n.msg("仓储"), value: 4, type:"success"},
        {label: i18n.msg("弃件"), value: 6, type:"danger"},
        {label: i18n.msg("寄回"), value: 7, type:"warning"},
        {label: i18n.msg("集运"), value: 8, type:"warning"},
        {label: i18n.msg("海快"), value: 9, type:"warning"},
        {label: i18n.msg("虾皮"), value: 10, type:"warning"},
    ],
    orderPlatforms:[
        {label: i18n.msg("虾皮"), value: 0, type:"success"},
        {label: i18n.msg("露天"), value: 1, type:"success"},
        {label: i18n.msg("奇摩"), value: 2, type:"success"},
        {label: i18n.msg("无"), value: 3, type:"success"},
        {label: i18n.msg("PC home"), value: 4, type:"success"},
        {label: i18n.msg("绿界"), value: 5, type:"success"},
        {label: i18n.msg("超商"), value: 6, type:"success"},
        {label: i18n.msg("虾皮(离线)"), value: 7, type:"success"},
        {label: i18n.msg("樂天市場"), value: 8, type:"success"},
        {label: i18n.msg("Shopline"), value: 9, type:"success"},
        {label: i18n.msg("MOMO"), value: 10, type:"warning"},
        {label: i18n.msg("Yahoo拍賣"), value: 11, type:"warning"},
        {label: i18n.msg("Coupang"), value: 12, type:"warning"},
    ],
    expoutType:[//出货方式
        //0-仓储贴面单，1-贴面单出货，2-线下已建单，3-线下未建单，4-弃件下架，5-退件寄回，6-打包验货',
        {label: i18n.msg("仓储贴面单"), value: 0, type:"success"},
        {label: i18n.msg("贴面单出货"), value: 1, type:"success"},
        {label: i18n.msg("线下已建单"), value: 2, type:"success"},
        {label: i18n.msg("线下未建单"), value: 3, type:"success"},
        {label: i18n.msg("弃件下架"), value: 4, type:"danger"},
        {label: i18n.msg("退件寄回"), value: 5, type:"warning"},
        {label: i18n.msg("打包验货"), value: 6, type:"success"},
    ],
    transportType:[//运输方式
        //0-海快，1-空运，2-新航线
        {label: i18n.msg("无"), value: "无", type:"success"},
        {label: i18n.msg("海快"), value: "海快", type:"success"},
        {label: i18n.msg("空运"), value: "空运", type:"success"},
        {label: i18n.msg("新航线"), value: "新航线", type:"success"},
    ],
    transportTypeInout:[//运输方式
        //0-海快，1-空运，2-新航线
        {label: i18n.msg("海快"), value: "海快", type:"success"},
        {label: i18n.msg("空运"), value: "空运", type:"success"},
        {label: i18n.msg("新航线"), value: "新航线", type:"success"},
    ],
    batchStatus:[
        {value: 75, label: "转配送", type: "primary"},
    ],
    expCompany: [
        {label: i18n.msg("7-11"), value: '7-11', type:"info"},
        {label: i18n.msg("全家"), value: '全家', type:"danger"},
        {label: i18n.msg("萊爾富"), value: '萊爾富', type:"primary"},
        {label: i18n.msg("OK"), value: 'OK', type:"warning"},
        {label: i18n.msg("黑貓"), value: '黑貓', type:"success"},
        {label: i18n.msg("賣家宅配"), value: '賣家宅配', type:"success"},
        {label: i18n.msg("黑貓宅急便"), value: '黑貓宅急便', type:"success"},
        // {label: i18n.msg("蝦皮宅配"), value: '蝦皮宅配', type:"success"},
        {label: i18n.msg("宅配通"), value: '宅配通', type:"success"},
        {label: i18n.msg("蝦皮店到店"), value: '蝦皮店到店', type:"success"},
        {label: i18n.msg("蝦皮隔日到"), value: '蝦皮隔日到', type:"success"},
        {label: i18n.msg("店到家宅配"), value: '店到家宅配', type:"success"},
        {label: i18n.msg("香港件"), value: '香港件', type:"success"},
        {label: i18n.msg("新竹"), value: '新竹', type:"info"},
        {label: i18n.msg("新竹物流"), value: '新竹物流', type:"info"},
        {label: i18n.msg("大荣"), value: '大荣', type:"primary"},
        {label: i18n.msg("东风"), value: '东风', type:"primary"},
        // {label: i18n.msg("海快"), value: '海快', type:"primary"},
        // {label: i18n.msg("海快蝦宅"), value: '海快蝦宅', type:"primary"},
        // {label: i18n.msg("聚鼎"), value: '聚鼎', type:"primary"},
        // {label: i18n.msg("露天拍卖"), value: '露天拍卖', type:"success"},
        {label: i18n.msg("无配送"), value: '无配送', type:"success"},
        {label: i18n.msg("菲律宾"), value: 'J&TExpres', type:"success"},
        {label: i18n.msg("自提"), value: '自提', type:"success"},
        // {label: i18n.msg("本地仓"), value: '本地仓', type:"success"},
        {label: i18n.msg("嘉里快遞"), value: '嘉里快遞', type:"success"},
        {label: i18n.msg("蝦皮日本-宅配 (其他)"), value: '蝦皮日本-宅配(其他)', type:"success"},
        {label: i18n.msg("蝦皮日本-蝦皮店到店"), value: '蝦皮日本-蝦皮店到店', type:"success"},
        {label: i18n.msg("蝦皮店到店-環保無包装"), value: '蝦皮店到店-環保無包装', type:"success"},
    ],
    expCompanyCode:[
        {label: i18n.msg("7-11"), value: 'YY'},
        {label: i18n.msg("全家"), value: 'JJ'},
        {label: i18n.msg("萊爾富"), value: 'EE'},
        {label: i18n.msg("OK"), value: 'KK'},
        {label: i18n.msg("黑貓"), value: 'MM'},
        {label: i18n.msg("賣家宅配"), value: 'MZ'},
        {label: i18n.msg("黑貓宅急便"), value: 'BB'},
        {label: i18n.msg("宅配通"), value: 'PP'},
        {label: i18n.msg("蝦皮店到店"), value: 'DD'},
        {label: i18n.msg("蝦皮隔日到"), value: 'DDG'},
        {label: i18n.msg("店到家宅配"), value: 'DJ'},
        {label: i18n.msg("店到家宅配-標準包裹"), value: 'DJB'},
        {label: i18n.msg("店到家宅配-大型包裹"), value: 'DJD'},
        {label: i18n.msg("新竹"), value: 'XX'},
        {label: i18n.msg("新竹物流"), value: 'XW'},
        {label: i18n.msg("大荣"), value: 'RR'},
        {label: i18n.msg("东风"), value: 'FF'},
        {label: i18n.msg("香港件"), value: 'HK'},
        {label: i18n.msg("无配送"), value: 'WW'},
        {label: i18n.msg("菲律宾"), value: 'LL'},
        {label: i18n.msg("自提"), value: 'ZT'},
        {label: i18n.msg("嘉里快遞"), value: 'JL'},
        {label: i18n.msg("嘉里大榮"), value: 'JR'},
        {label: i18n.msg("蝦皮日本-宅配(其他)"), value: 'RZ'},
        {label: i18n.msg("蝦皮日本-蝦皮店到店"), value: 'RD'},
        {label: i18n.msg("蝦皮店到店-環保無包装"), value: 'DDW'},
        {label: i18n.msg("酷陌新竹"), value: 'CM'},
        // {label: i18n.msg("蝦皮宅配"), value: 'PP'},
        // {label: i18n.msg("海快"), value: 'HH'},
        // {label: i18n.msg("海快蝦宅"), value: 'HP'},
        // {label: i18n.msg("海运"), value: '海运'},
        // {label: i18n.msg("空运"), value: '空运'},
        // {label: i18n.msg("聚鼎"), value: 'UU'},
        // {label: i18n.msg("露天拍卖"), value: 'TT'},
        // {label: i18n.msg("本地仓"), value: 'XH'},
    ], 
    expCompanyInout: [
        {label: i18n.msg("7-11"), value: '7-11', type:"info"},
        {label: i18n.msg("全家"), value: '全家', type:"danger"},
        {label: i18n.msg("萊爾富"), value: '萊爾富', type:"primary"},
        {label: i18n.msg("OK"), value: 'OK', type:"warning"},
        {label: i18n.msg("黑貓"), value: '黑貓', type:"success"},
        {label: i18n.msg("賣家宅配"), value: '賣家宅配', type:"success"},
        {label: i18n.msg("黑貓宅急便"), value: '黑貓宅急便', type:"success"},
        // {label: i18n.msg("蝦皮宅配"), value: '蝦皮宅配', type:"success"},
        {label: i18n.msg("宅配通"), value: '宅配通', type:"success"},
        {label: i18n.msg("蝦皮店到店"), value: '蝦皮店到店', type:"success"},
        {label: i18n.msg("蝦皮隔日到"), value: '蝦皮隔日到', type:"success"},
        {label: i18n.msg("店到家宅配"), value: '店到家宅配', type:"success"},
        {label: i18n.msg("香港件"), value: '香港件', type:"success"},
        {label: i18n.msg("新竹"), value: '新竹', type:"info"},
        {label: i18n.msg("新竹物流"), value: '新竹物流', type:"info"},
        {label: i18n.msg("大荣"), value: '大荣', type:"primary"},
        {label: i18n.msg("东风"), value: '东风', type:"primary"},
        // {label: i18n.msg("海快"), value: '海快', type:"primary"},
        // {label: i18n.msg("海快蝦宅"), value: '海快蝦宅', type:"primary"},
        // {label: i18n.msg("海运"), value: '海运', type:"primary"},
        // {label: i18n.msg("空运"), value: '空运', type:"primary"},
        // {label: i18n.msg("聚鼎"), value: '聚鼎', type:"primary"},
        // {label: i18n.msg("露天拍卖"), value: '露天拍卖', type:"success"},
        {label: i18n.msg("无配送"), value: '无配送', type:"success"},
        {label: i18n.msg("菲律宾"), value: 'J&TExpres', type:"success"},
        {label: i18n.msg("嘉里快遞"), value: '嘉里快遞', type:"success"},
        {label: i18n.msg("蝦皮日本-宅配 (其他)"), value: '蝦皮日本-宅配(其他)', type:"success"},
        {label: i18n.msg("蝦皮日本-蝦皮店到店"), value: '蝦皮日本-蝦皮店到店', type:"success"},
        {label: i18n.msg("蝦皮店到店-環保無包装"), value: '蝦皮店到店-環保無包装', type:"success"},
    ],
    transformType:[
        // {label: i18n.msg("空运"), value: '空运', type:"primary"},
        // {label: i18n.msg("海运"), value: '海运', type:"success"},
        {label: i18n.msg("无配送"), value: '无配送', type:"success"},
        {label: i18n.msg("自退"), value: '自退', type:"danger"},
        // {label: i18n.msg("本地仓"), value: '本地仓', type:"danger"},
    ],
    stockStatus: [
        {value: 0, label: "待入仓", type: "primary"},
        {value: 5, label: "待认领", type: "primary"},
        {value: 10, label: "已入仓", type: "success"},
        {value: 13, label: "待备货", type: "warning"},
        {value: 15, label: "备货中", type: "primary"},
        {value: 20, label: "待打包", type: "warning"},
        {value: 23, label: "已打单", type: "success"},
        {value: 25, label: "打包中", type: "warning"},
        {value: 30, label: "待出仓", type: "primary"},
        {value: 35, label: "已打包", type: "success"},
        {value: 40, label: "待揽收", type: "primary"},
        {value: 45, label: "已揽收", type: "primary"},
        {value: 50, label: "已发货", type: "success"},
        {value: 55, label: "转运中", type: "primary"},
        {value: 60, label: "待验中", type: "primary"},
        {value: 65, label: "已清关", type: "primary"},
        {value: 70, label: "已提货", type: "success"},
        {value: 75, label: "转配送", type: "primary"},
        {value: 77, label: "转库存", type: "success"},
        {value: 79, label: "已取消", type: "danger"},
        {value: 80, label: "截货中", type: "danger"},
        {value: 85, label: "已拆包", type: "primary"},
        {value: 90, label: "待转寄", type: "primary"},
        {value: 95, label: "转寄中", type: "primary"},
        {value: 100, label: "已寄出", type: "primary"},
        {value: 105, label: "待寄回", type: "primary"},
        {value: 110, label: "下架中", type: "primary"},
        {value: 115, label: "寄回中", type: "primary"},
        {value: 120, label: "已寄回", type: "primary"},
        {value: 125, label: "待弃件", type: "primary"},
        {value: 130, label: "弃件中", type: "primary"},
        {value: 135, label: "已弃件", type: "primary"},
    ],
    //在order中查询所需要的状态值
    stockStatusInOrder: [
        {value: 13, label: "待备货", type: "warning"},
        {value: 15, label: "备货中", type: "primary"},
        {value: 20, label: "待打包", type: "warning"},
        {value: 23, label: "已打单", type: "success"},
        {value: 25, label: "打包中", type: "warning"},
        {value: 79, label: "已取消", type: "danger"},
        {value: 80, label: "截货中", type: "danger"},
    ],
    stockStatus1: [
        {value: 10, label: "已入仓", type: "success"},
        {value: 85, label: "已拆包", type: "primary"},
        {value: 100, label: "已寄出", type: "primary"},
    ],

    agreementStatuses: [
        {value: 0, label: "未签约", type: "primary"},
        {value: 1, label: "签约中", type: "warning"},
        {value: 2, label: "审核中", type: "primary"},
        {value: 3, label: "未通过", type: "danger"},
        {value: 4, label: "已签约", type: "success"},
        {value: 5, label: "已实名", type: "success"},
        {value: 6, label: "实名签约", type: "success"},
    ],

    filterUserOptionTypes: [
        {label: i18n.msg("用户身份标识"), key: "adminTypes"},
        {label: i18n.msg("性别"), key: "genders"},
        {label: i18n.msg("用户会员身份"), key: "vipTypes"},
        {label: i18n.msg("用户状态"), key: "userEditStatuses"},
        {label: i18n.msg("是否默认"), key: "defaulteds"},
        {label: i18n.msg("用户协议状态"), key: "agreementStatuses"},
    ],
    filterStoreOptionTypes: [
        {label: i18n.msg("面单状态"), key: "stockExpPageStatus"},
        {label: i18n.msg("配送类别"), key: "stockExpType"},
        {label: i18n.msg("打包类型"), key: "stockExpPkgType"},
        {label: i18n.msg("仓储类型"), key: "stockStoreType"},
        {label: i18n.msg("入仓标签"), key: "stockInStoreStatus"},
        {label: i18n.msg("异常状态"), key: "stockErrStatus"},
        {label: i18n.msg("是否含税"), key: "stockHasTax"},
        {label: i18n.msg("店铺类型"), key: "shopTypes"},
        {label: i18n.msg("台湾物流公司"), key: "expCompany"},
        {label: i18n.msg("货物状态"), key: "stockStatus"},
        {label: i18n.msg("能否列印面单"), key: "stockExpAllowPrint"},
        {label: i18n.msg("货物类型"), key: "stockExpGoodType"},
        {label: i18n.msg("出货方式"), key: "expoutType"},
        {label: i18n.msg("订单来源"), key: "orderOrigin"},
        {label: i18n.msg("订单卖场"), key: "orderPlatforms"},
        {label: i18n.msg("是否取消"), key: "cances"},
        {label: i18n.msg("异常类型"), key: "errorTypes"},
        {label: i18n.msg("理赔状态"), key: "payStatus"},
        {label: i18n.msg("计费方式"), key: "feeTypes"},
        {label: i18n.msg("运费结算状态"), key: "transitStatuses"},
        {label: i18n.msg("回款结算状态"), key: "payInStatuses"},
        {label: i18n.msg("采购状态"), key: "purchaseStatuses"},
        {label: i18n.msg("等级"), key: "levelStatuses"},
        {label: i18n.msg("物流状态"), key: "trackStatus"},
    ],
    
    purchaseStatusInOrder:[
        {value: 0, label: i18n.msg("未采购"), type: "danger"},
        {value: 1, label: i18n.msg("已采购"), type: "success"},
    ], 
    purchaseStatusInOrderQuery:[
        {value: 2, label: i18n.msg("未采购"), type: "danger"},
        {value: 1, label: i18n.msg("已采购"), type: "success"},
    ],
    existOptions:[
        {value: 2, label: i18n.msg("无"), type: "danger"},
        {value: 1, label: i18n.msg("有"), type: "success"},
    ], 
    //订单管理的视图定制中的类型字段
    filterOrderOptionTypes: [
        {label: i18n.msg("货物状态"), value: "stockStatusInOrder", key: "stockStatusInOrder"},
        {label: i18n.msg("采购类型"), value: "purchaseStatusInOrder", key: "purchaseStatusInOrder"},
        {label: i18n.msg("打包类型"), value: "stockExpPkgType", key: "stockExpPkgType"},
        {label: i18n.msg("货物类型"), value: "stockExpGoodType", key: "stockExpGoodType"},
        {label: i18n.msg("快递"), value: "existOptions", key: "existExpCode"},
        {label: i18n.msg("采购链接"), value: "existOptions", key: "existLink"},
        {label: i18n.msg("配送方式"), value: "expCompany", key: "expCompany"},
    ],

    cances:[
        {value: 0, label: "正常", type: "success"},
        {value: 1, label: "取消", type: "danger"},
        {value: 2, label: "已取消", type: "danger"},
    ],
    transitTypes:[
        {value: 0, label: i18n.msg("空运"), type: "success"},
        {value: 1, label: i18n.msg("海运"), type: "primary"},
        {value: 2, label: i18n.msg("按票"), type: "danger"},
    ],
    //运费结算状态
    transitStatuses:[
        {value: 0, label: i18n.msg("未计算"), type: "success"},
        {value: 1, label: i18n.msg("待付"), type: "primary"},
        {value: 2, label: i18n.msg("已付"), type: "danger"},
        {value: 3, label: i18n.msg("已出账单"), type: "danger"},
    ], 
    //结算状态
    transitStatuses1:[
        {value: 0, label: i18n.msg("未计算"), type: "warning"},
        {value: 1, label: i18n.msg("计算成功"), type: "primary"},
        {value: 2, label: i18n.msg("已出账单"), type: "success"},
        {value: 3, label: i18n.msg("计算失败"), type: "danger"},
        {value: 4, label: i18n.msg("不计算"), type: "danger"},
    ], 
    //回款结算状态
    payInStatuses:[
        {value: 0, label: i18n.msg("未计算"), type: "success"},
        {value: 1, label: i18n.msg("待付"), type: "primary"},
        {value: 2, label: i18n.msg("已付"), type: "danger"},
    ], 
    purchaseStatuses:[
        {value: 0, label: i18n.msg("待采购"), type: "danger"},
        {value: 1, label: i18n.msg("已采购"), type: "success"},
    ], 
    levelStatuses:[
        {value: 0, label: i18n.msg("无"), type: "success"},
        {value: 1, label: i18n.msg("一级"), type: "primary"},
        {value: 2, label: i18n.msg("二级"), type: "warning"},
        {value: 3, label: i18n.msg("三级"), type: "danger"},
    ],
    errorTypes:[
        {label: i18n.msg("MD面单异常"), value: i18n.msg("MD面单异常")},
        {label: i18n.msg("WD没有面单"), value: i18n.msg("WD没有面单")},
        {label: i18n.msg("GQ面单过期"), value: i18n.msg("GQ面单过期")},
        {label: i18n.msg("BG包裹破损"), value: i18n.msg("BG包裹破损")},
        {label: i18n.msg("CC包裹超材"), value: i18n.msg("CC包裹超材")},
        {label: i18n.msg("WL物流异常"), value: i18n.msg("WL物流异常")},
        {label: i18n.msg("DZ地址异常"), value: i18n.msg("DZ地址异常")},
        {label: i18n.msg("LP理赔通报"), value: i18n.msg("LP理赔通报")},
        {label: i18n.msg("DS包裹丢失"), value: i18n.msg("DS包裹丢失")},
        {label: i18n.msg("WJ暂未见货"), value: i18n.msg("WJ暂未见货")},
        {label: i18n.msg("SL数量不对"), value: i18n.msg("SL数量不对")},
        {label: i18n.msg("BD货不对版"), value: i18n.msg("BD货不对版")},
        {label: i18n.msg("JY违禁禁运"), value: i18n.msg("JY违禁禁运")},
        {label: i18n.msg("YS颜色不符"), value: i18n.msg("YS颜色不符")},
    ],
    trackStatus:[//物流状态
        {label: "未寄件", value: "未寄件"},
        {label: "配送中", value: "配送中"},
        {label: "已签收", value: "已签收"},
        {label: "退件中", value: "退件中"},
        {label: "已退件", value: "已退件"},
        {label: "异常件", value: "异常件"},
    ],
    payStatus:[//理赔状态
        {label: i18n.msg("无"), value: 0},
        {label: i18n.msg("未理赔"), value: 1},
        {label: i18n.msg("已理赔"), value: 2},
    ],
    detailReport:[//报单状态
        {label: i18n.msg("未报单"), value: 0,type: "danger"},
        {label: i18n.msg("已报单"), value: 1,type: "warning"},
        {label: i18n.msg("已受理"), value: 2,type: "success"},
    ],
    workOrderType: [
        {label: i18n.msg("查件催件"), value: 1},
        {label: i18n.msg("资料面单"), value: 2},
        {label: i18n.msg("快递包裹"), value: 3},
        {label: i18n.msg("财务账单"), value: 4},
        {label: i18n.msg("客服咨询"), value: 5},
        {label: i18n.msg("系统技术"), value: 6},
    ],
    workOrderLevel: [
        {label: i18n.msg("正常"), value: 0},
        {label: i18n.msg("较急"), value: 1},
        {label: i18n.msg("超急"), value: 2},
    ],
    workOrderStatus: [
        {label: i18n.msg("待受理"), value: 0},
        {label: i18n.msg("处理中"), value: 1},
        {label: i18n.msg("已完结"), value: 2},
        {label: i18n.msg("已评价"), value: 3},
    ],
    workOrderComment: [
        {label: i18n.msg("非常满意"), value: 4},
        {label: i18n.msg("满意"), value: 3},
        {label: i18n.msg("一般"), value: 2},
        {label: i18n.msg("差评"), value: 1},
    ],
    workOrderCommentResult: [
        {label: i18n.msg("未解决"), value: 0},
        {label: i18n.msg("部分解决"), value: 1},
        {label: i18n.msg("已解决"), value: 2},
    ],
    stockBtns:[
        {name: '刷新', icon: 'icon-shuaxin1', 
            permission: null, action: 'list', para: true,
            children: null,
        },
        {name: '高级搜索', icon: 'icon-gaojisousuo', 
            permission: null, action: 'showAdvSearch', para: null,
            children: null,
        },
        {name: '提交工单', icon: 'icon-xiaoxiguanli',
            permission: null, action: 'workOrderAdd', para: null,
            children: null,
        },
        {name: '总数', icon: 'icon-zongshu', 
            permission: null, action: 'showSelectTotal', para: null,
            children: null,
        },
        {name: '同步店铺订单', icon: 'icon-tongbudingdan', 
            permission: ['stock:syncOrder'], action: 'doSyncOrder', para: null,
            children: null,
        },
        {name: '一键发货', icon: 'icon-yijianfahuo', 
            permission: ['stock:batchSendOrder'], action: 'doBatchSendOrderNew', para: null,
            children: null,
        },
        {name: '同步面单', icon: 'icon-xitongshezhi_tuxiang-copy', 
            permission: ['stock:shipOrder'], action: 'doBatchSendOrder', para: null,
            children: null,
        },
        {name: '预览详情', icon: 'icon-chakan', 
            permission: ['stock:detail0'], action: 'stockDetail', para: null, 
            // iconStyle: {display: "inline-block;", marginTop: "3px"},
            // labelStyle: {display: "inline-block;",marginTop: "4px"},
            children: null,
        },
        {name: '货物采购', icon: 'icon-huowucaigou', 
            permission: ['stock:buy'], action: 'stockDetailBuy', para: null,
            children: null,
        },
        {name: '快递同步', icon: 'icon-kuaiditongbu', 
            permission: null, action: 'doTrackExpress', para: null,
            children: null,
        },
        {name: '批量更新', icon: 'icon-pilianggengxin1', 
            permission: ['stock:batchFieldAll'], action: 'doBatchUpdate', para: null,
            children: null,
        },
        {name: '组合更新', icon: 'icon-pilianggengxin1', 
            permission: ['stock:batchUpdateZuhe'], action: 'doBatchUpdateNew', para: null,
            children: null,
        },
        {name: '入仓出仓', icon: 'icon-rucangchucang', 
            permission: ['stock:inout'], action: 'doInOut', para: null,
            children: null,
        },
        {name: '待备货', icon: 'icon-daibeihuo', 
            permission: ['stock:daibeihuo'], action: 'stockEditStatus', para: null,
            children: null,
        },
        {name: '新增', icon: 'icon-xinzengdingdan', 
            permission: ['stock:create0',
                        'stock:create1',
                        'stock:create2',
                        'stock:create3',
                        'stock:create4'
                        ], 
            action: 'handleAdd', para: null,
            children: [
                // {name: '新增货运订单', command:'a', permission: ['stock:create1']},
                {name: '新增线下订单', command:'b', permission: ['stock:create2']},
                {name: '新增店配订单', command:'c', permission: ['stock:create3']},
                {name: '新增现货仓储', command:'d', permission: ['stock:create4']},
            ],
        },
        {name: '导入', icon: 'icon-daoru2', 
            permission: ['stock:import0','stock:onlyPageImport'], action: 'handleImport', para: null,
            children: [
                {name: '导入EXCEL资料', command:'a', permission: ['stock:import0']},
                {name: '导入PDF资料', command:'b', permission: ['stock:onlyPageImport']}
            ],
        },
        {name: '导出', icon: 'icon-daochu1', 
            permission: ['stock:export',
                        'stock:downloadQingguan',
                        'stock:downloadHangkong',
                        'stock:downloadHeimao',
                        'stock:downloadTihuo',
                        'stock:downloadTongji',
                        'stock:downloadStatus',
                        'stock:downloadBaoJi'], 
            action: 'handleExport', para: null,
            children: [
                {name: '导出列表', command:'a', permission: ['stock:export']},
                {name: '导出航空资料', command:'c', permission: ['stock:downloadHangkong']},
                {name: '导出报机资料', command:'l', permission: ['stock:downloadBaoJi']},
                {name: '导出清关资料', command:'b', permission: ['stock:downloadQingguan']},
                {name: '导出派件资料', command:'d', permission: ['stock:downloadHeimao']},
                {name: '导出建单资料', command:'f', permission: null},
                {name: '导出提货表', command:'e', permission: ['stock:downloadTihuo']},
                {name: '出货统计', command:'g', permission: ['stock:downloadTongji']},
                {name: '导出详情', command:'h', permission: null},
                {name: '导出物流记录', command:'j', permission: ['stock:downloadStatus']},
                {name: '导出采购详情', command:'k', permission: null},
                {name: '导出转寄成本', command:'m', permission: null},
                {name: '导出面单图片', command:'n', permission: null},
                {name: '品名关键词导出', command:'o', permission: ['stock:downloadHangkong']}, 
            ],
        },
        // {name: '导出面单图', icon: 'icon-daochu1',
        //     permission: null, action: 'doPagePicExport', para: null,
        //     children: null,
        // },
        {name: '打印', icon: 'icon-dayin2', 
            permission: ['stock:print','stock:printTag','stock:printFapiao'], action: 'handlePrint', para: null,
            children: [
                {name: '打印拣货单', command:'a', permission: null},
                {name: '打印出货码', command:'y', permission: null},
                {name: '打印查询码', command:'t', permission: null},
                {name: '打印自定义面单', command:'custom', permission: null},
                {name: '打印拣货单&出货码', command:'z', permission: null},
                {name: '打印拣货单&查询码', command:'s', permission: null},
                {name: '打印自定义快递单', command:'l', permission: null},
                {name: '打印拣货单&自定义快递单', command:'r', permission: null},
                {name: '打印中通快递单', command:'v', permission: null},
                {name: '打印拣货单&中通快递单', command:'w', permission: null},
                {name: '打印货物图', command:'c', permission: null},
                {name: '打印面单', command:'b', permission: null},
                {name: '打印货单&面单', command:'d', permission: null},
                {name: '打印货单&货物图', command:'e', permission: null},
                {name: '打印面单&货物图', command:'f', permission: null},
                {name: '打印货单&面单&货物图', command:'g', permission: null},
                // {name: '打印实名单', command:'h', permission: null},
                // {name: '打印实名发票', command:'m', permission: null},
                // {name: '打印网购货物发票', command:'o', permission: ['stock:printWg']},
                {name: '打印标签', command:'n', permission: ['stock:printTag']},
                {name: '打印包裹单', command:'k', permission: null},
                // {name: '打印报关单', command:'i', permission: ['declare:print']},
                // {name: '自动打印实名发票单', command:'j', permission: null},
                // {name: '打印发票', command:'u', permission: ['stock:printFapiao']},
                {name: '打印库签', command:'q', permission: null},
            ],
        },
        {name: '打货单', icon: 'icon-dahuodan', 
            permission: ['stock:OnlyOnePrint'], action: 'handlePrintOne', para: null,
            children: null,
        },
        // {name: '财务', icon: 'icon-caiwu', 
        //     permission: ['finance:transitType','finance:transit','finance:proxy'], action: 'finance', para: null,
        //     children: [
        //         {name: '更新收费方式', command:'a', permission: ['finance:transitType']},
        //         {name: '运费核算', command:'b', permission: ['finance:transit']},
        //         {name: '回款核算', command:'c', permission: ['finance:proxy']},
        //         {name: '理赔核算', command:'d', permission: ['finance:proxy']},
        //         {name: '客诉件核算', command:'e', permission: ['finance:proxy']},
        //     ],
        // },
        {name: '物流记录', icon: 'icon-wuliujilu', 
            permission: ['stock:trace'], action: 'doTrace', para: null,
            children: null,
        },
        {name: '货态同步', icon: 'icon-huotaitongbu', 
            permission: ['stock:doTrack'], action: 'doTrack', para: null,
            children: null,
        },
        {name: '同步收件电话', icon: 'icon-dianhua', 
            permission: null, action: 'getReveicerTel', para: null,
            children: null,
        },
        {name: '上传面单', icon: 'icon-shangchuangmiandan', 
            permission: ['stock:pageImport'], action: 'pageImport', para: null,
            children: null,
        },
        {name: '订单拆分', icon: 'icon-fuzhi', 
            permission: ["stock:orderDetailSplit"], action: 'doOrderDetailSplit', para: null,
            children: null,
        },
        {name: '详情修改', icon: 'icon-xiangqingxiugai', 
            permission: null, action: 'stockDetailEdit', para: null,
            children: null,
        },
        {name: '快递货物', icon: 'icon-kuaidihuowu', 
            permission: null, action: 'kuaidi', para: null,
            children: null,
        },
        // {name: '详情分拆', icon: 'icon-xiangqingchaifen', 
        //     permission: ["stock:split"], action: 'stockSplit', para: null,
        //     children: null,
        // },
        {name: '货物转寄', icon: 'icon-huowuzhuanji', 
            permission: ["stock:stockSelect"], action: 'selectStock', para: null,
            children: null,
        },
        {name: '打包', icon: 'icon-dabao1', 
            permission: ['stock:insertPkgCode','stock:autoPkgCode'], action: 'handleInsertPkgCode', para: null,
            children: [
                {name: '包号录入', command:'a', permission: ['stock:insertPkgCode']},
                {name: '扫码打包', command:'b', permission: ['stock:autoPkgCode']},
            ],
        },
        {name: '转运', icon: 'icon-zhuanyun', 
            permission: ["stock:zhuanyunPkg","stock:pkgResend","stock:qijian","stock:zhuanyunRemark1","stock:noticeSend"], action: 'zhuanyunCommon', para: null,
            children: [
                {name: '集运转运', command:'a', permission: ["stock:zhuanyunPkg"]},
                {name: '集运付费', command:'d', permission: ["stock:zhuanyunRemark1"]},
                {name: '通知出货', command:'e', permission: ["stock:noticeSend"]},
                {name: '包裹回寄', command:'b', permission: ["stock:pkgResend"]},
                {name: '弃件处理', command:'c', permission: ["stock:qijianHandle"]},
            ],
        },
        {key: "markGoodType", name: '普特货', icon: 'icon-putebiaoji', 
            permission: ["stock:updateGoodType"], action: 'handleGoodType', para: null,
            children: [
                {name: '标记普货', command:'0', permission: ["stock:updateGoodType"]},
                {name: '标记特货', command:'1', permission: ["stock:updateGoodType"]},
                {name: 'C食品', command:'2', permission: ["stock:updateGoodType"]},
                {name: 'D电池类', command:'3', permission: ["stock:updateGoodType"]},
                {name: 'Y液体类', command:'4', permission: ["stock:updateGoodType"]},
                {name: 'F(仿敏货别)', command:'5', permission: ["stock:updateGoodType"]},
            ],
        },
        {name: '代打包', icon: 'icon-daidabao1', 
            permission: ["stock:updatePkgType","stock:updatePkgTypeNew"], action: 'handlePkgType', para: null,
            children: [
                {name: '货运代打包', command:'a', permission: ["stock:updatePkgType"]},
                {name: '跨仓合并包', command:'d', permission: ["stock:updatePkgType"]},
                {name: '代打包扫码登记', command:'b', permission: null},
                {name: '代打包登记NEW', command:'c', permission: ["stock:updatePkgTypeNew"]},
            ],
        },
        {name: '仓储贴单', icon: 'icon-cangchutiedan', 
            permission: ["stock:updateOutType"], action: 'doUpdateOutType', para: null,
            children: null,
        },
        {name: '打包完成', icon: 'icon-dabaowancheng', 
            permission: ["stock:finishPackage"], action: 'doFinishPakage', para: null,
            children: null,
        },
        {name: '通知收件', icon: 'icon-tongzhishoujian', 
            permission: ["stock:updateReceive"], action: 'receiveStock', para: null,
            children: null,
        },
        {name: '虚拟揽收', icon: 'icon-xunilanshou', 
            permission: ["stock:xuniReceive"], action: 'xuniReceiveStock', para: null,
            children: null,
        },
        {name: '出货时间', icon: 'icon-chuhuoshijian', 
            permission: ["stock:updateWeightTime"], action: 'updateWeightTime', para: null,
            children: null,
        },
        {name: '取消订单', icon: 'icon-quxiaohuifu', 
            permission: ["stock:cancel"], action: 'handleCancel', para: null,
            children: [
                {name: '取消', command:'a', permission: ["stock:cancel"]},
                {name: '恢复', command:'b', permission: ["stock:cancel"]},
                {name: '处理虾皮取消申请', command:'c', permission: ["stock:cancel"]},
            ],
        },
        {name: '贴单校对', icon: 'icon-tiedanxiaodui', 
            permission: ["stock:codeCheck"], action: 'stockCodeCheck', para: null,
            children: null,
        },
        // {name: '扫码入库', icon: 'icon-saomaruku', 
        //     permission: null, action: 'checkCodeInStore', para: null,
        //     children: null,
        // },
        // {name: '入库出库', icon: 'icon-rukuchuku', 
        //     permission: ["stock:qtyEdit"], action: 'stockQtyEdit', para: null,
        //     children: null,
        // },
        {name: '智能理货', icon: 'icon-zhinenglihuo', 
            permission: ["stock:expSort","stock:stockSort"], action: 'zhineng', para: null,
            children: [
                {name: '快递分拣', command:'a', permission: ["stock:expSort"]},
                {name: '库存分拣', command:'b', permission: ["stock:stockSort"]},
            ],
        },
        {name: '快速找货', icon: 'icon-kuaisuzhaohuo', 
            permission: ['stock:resendTicket','stock:detailTicket','stock:packageTicket'], action: 'handleFindTicket', para: null,
            children: [
                {name: '转寄找货单', command:'a', permission: ['stock:resendTicket']},
                {name: '转运找货单', command:'b', permission: ['stock:detailTicket']},
                {name: '待贴单包裹', command:'c', permission: ['stock:packageTicket']},
            ],
        },
        {name: '扫码找货', icon: 'icon-saomazhaohuo', 
            permission: null, action: 'scanCodeFun', para: null,
            children: null,
        },
        {name: '出货核对', icon: 'icon-chuhuohedui', 
            permission: ["stock:stockCheck",'stock:declareCheck'], action: 'stockCheck', para: null,
            children: [
                {name: '出货校对', command:'a', permission: ['stock:stockCheck']},
                {name: '申报校对', command:'b', permission: ['stock:declareCheck']},
            ],
        },
        {name: '货物交接', icon: 'icon-huowujiaojie', 
            permission: null, action: 'handover', para: null,
            children: null,
        },
        {name: '建单操作', icon: 'icon-jiandancaozuo', 
            permission: ['stock:offlineCreate','stock:updateOutTypeFinish'], action: 'handleOfflineCreate', para: null,
            children: [
                {name: '快速建单', command:'a', permission: ['stock:offlineCreate']},
                {name: '完成建单', command:'b', permission: ['stock:updateOutTypeFinish']},
                {name: '重新建单', command:'c', permission: null},
                {name: '录查询码', command:'e', permission: null},
                {name: '同步线下面单', command:'d', permission: ['stock:offlineCreate']},
                {name: '同步新竹区码', command:'f', permission: ['stock:syncXzAddressCode']},
                {name: '录退件码', command:'g', permission: null},
            ],
        },
        {name: '分包加单', icon: 'icon-fenbaojiadan', 
            permission: ["stock:addStockPkg"], action: 'addStockPkg', para: null,
            children: null,
        },
        {name: '重量分摊', icon: 'icon-zhongliangfentan', 
            permission: ["stock:weightShare"], action: 'weightShare', para: null,
            children: null,
        },
        {name: '面单催收', icon: 'icon-miandancuishou', 
            permission: ["stock:allowUpload"], action: 'handleAllowUpload', para: null,
            children: [
                {name: '通知上传面单', command:'a', permission: ["stock:allowUpload"]},
                {name: '撤回通知', command:'b', permission: ["stock:allowUpload"]},
            ],
        },
        {name: '异常通报', icon: 'icon-yichangtongbao', 
            permission: ["stock:stockErrAdd"], action: 'stockErrAdd', para: null,
            children: null,
        },
        {name: '同步Shopline订单', icon: 'icon-tongbudingdan',
            permission: null, action: 'syncAllShoplineOrders', para: null,
            children: null,
        },
        {name: '空白面单', icon: 'icon-kongbaimiandan', 
            permission: ['stock:batchSendOrder'], action: 'doBatchSendOrder1', para: null,
            children: null,
        },
        {name: '删除', icon: 'icon-piliangshanchu', 
            permission: ["stock:deleteAll"], action: 'doDelete', para: null,
            children: null,
        },
        {name: '单个删除', icon: 'icon-shanchu1', 
            permission: ["stock:deleteOne"], action: 'doDeleteOne', para: null,
            children: null,
        },
        {name: '批改卖家宅配', icon: 'icon-pilianggengxin1', 
            permission: null, action: 'doUpdateCompany', para: null,
            children: null,
        },
    ],
    //库存的仓储类型
    inventoryStoreTypes: [
        {label: i18n.msg("现货仓储"), value: 5, type: "primary"},
        {label: i18n.msg("退件仓储"), value: 10, type: "warning"},
        {label: i18n.msg("备货仓储"), value: 20, type: "success"},
        {label: i18n.msg("快递仓储"), value: 25, type: "success"},
        {label: i18n.msg("集运仓储"), value: 28, type: "success"},
        {label: i18n.msg("冻结仓储"), value: 39, type: "success"},
    ],
    filterInventoryOptionTypes: [
        {label: i18n.msg("库存状态"), key: "inventoryStatuses"},
        {label: i18n.msg("仓储类型"), key: "inventoryStoreTypes"},
        {label: i18n.msg("采购平台"), key: "productOrigin"}
    ],
    //库存的仓储状态
    inventoryStatuses: [
        {label: i18n.msg("待入仓"), value: 5, type: "primary"},
        {label: i18n.msg("已入仓"), value: 10, type: "success"},
        {label: i18n.msg("已拆包"), value: 85, type: "primary"},
        {label: i18n.msg("转寄中"), value: 95, type: "primary"},
        {label: i18n.msg("已寄出"), value: 100, type: "primary"},
        {label: i18n.msg("退件申请"), value: 105, type: "warning"},
        {label: i18n.msg("退件中"), value: 107, type: "warning"},
        {label: i18n.msg("已退件"), value: 110, type: "warning"},
        {label: i18n.msg("已弃件"), value: 135, type: "danger"},
    ],
    inventoryBatchUpdateStatuses: [
        {label: i18n.msg("已入仓"), value: 10, type: "success"},
        {label: i18n.msg("已寄出"), value: 100, type: "primary"},
    ],
    //仓库--仓库类型
    storeType:[
        {value: 0, label: "普通仓", type: "primary"},
        {value: 1, label: "首发仓", type: "success"},
        {value: 2, label: "中转仓", type: "success"},
        {value: 3, label: "前置仓", type: "success"},
    ],
    productOrigin:[
        {value: "taobao", label: "淘宝", type: "success"},
        {value: "alibaba", label: "1688", type: "success"},
        {value: "pdd", label: "拼多多", type: "success"},
    ],    
    inventoryInStatus: [
        {label: i18n.msg("已采购"), value: 5, type: "warning"},
        {label: i18n.msg("已发货"), value: 10, type: "success"},
        {label: i18n.msg("已签收"), value: 15, type: "primary"},
        {label: i18n.msg("已入库"), value: 20, type: "success"},
        {label: i18n.msg("已退件"), value: 25, type: "success"},
        {label: i18n.msg("申请退件"), value: 105, type: "success"},
        {label: i18n.msg("退件中"), value: 107, type: "success"},
        {label: i18n.msg("已退件"), value: 110, type: "success"},
    ],
    inventoryOutType:[
        {value: 0, label: "货物转寄", type: "danger"},
        {value: 1, label: "退件", type: "danger"},
        {value: 2, label: "入库", type: "success"},
        {value: 3, label: "出库", type: "danger"},
        {value: 4, label: "其他", type: "warning"},
        {value: 5, label: "整包整寄", type: "primary"},
        {value: 6, label: "撤销转寄", type: "info"},
    ],
}

/**
 * vue包装
 */
 const dictVue = {
    data(){
        return {
            dicts: dicts
        };
    },

    methods:{
        getDicts(key){
            return this.dicts[key];
        },
    }
}

export {
    dicts,
    dictVue
}
